// extracted by mini-css-extract-plugin
export default {"PfsRecordRetentions":"PFSRecordRetentions_PfsRecordRetentions__dYeWT","heading":"PFSRecordRetentions_heading__fylsY","paragraph":"PFSRecordRetentions_paragraph__YnAPW"};